// extracted by mini-css-extract-plugin
module.exports = {"card":"GameCard_card__EuyuA","front":"GameCard_front__2rld_","flipped":"GameCard_flipped__CynaO","back":"GameCard_back__jThyS"};